import { useEffect, useState } from 'react';

const links = [
  { href: '#hot', label: '今日热瓜' },
  { href: '#live', label: '围观现场' },
  { href: '#cates', label: '吃瓜分类' },
  { href: '#guide', label: '吃瓜指南' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于口碑' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70 shadow-sm'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-cup-line text-lg"></i>
          </span>
          <span className="font-heading text-xl leading-none text-primary-600">呱呱吃瓜</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#submit"
            className="flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-fire-line"></i>
            爆料投稿
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-fire-line"></i>
              爆料投稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}